import {useEffect, useSyncExternalStore} from "react";
import {livePreview} from "../utils/livePreview";
import {useApp} from "../app.context";

// Sidebar control for Live Theme Preview: broadcast the working theme
// (images / packs / sounds / tech-tree render) to your own running game
// sessions in real time. The room is keyed by your PlayFabId; until the
// backend's /me change is deployed everywhere, the id can be entered
// manually (it's shown in the game's console when its live_preview pref
// turns on).
function LivePreviewControl() {
    const status = useSyncExternalStore(livePreview.subscribe, livePreview.getSnapshot);
    const {playFabId} = useApp();

    // The logged-in account is the ONLY room key — pairing is "you can only see
    // yourself". The id comes solely from the verified session (/me); '' on
    // logout drops the room. There is nothing to configure and no manual entry:
    // a free-text uid let one editor publish into another user's game.
    useEffect(() => {
        livePreview.setUid(playFabId ?? '');
    }, [playFabId]);

    // Two independent signals: the icon colour reflects the relay connection
    // (green when connected, dimmed when not); the text colour reflects whether a
    // game is actually listening (green when a session is receiving). The
    // status/debug lines live in Settings → Debug Info (LivePreviewDebugInfo).
    const green = '#4caf50';

    return (
        <div className={'layout horizontal gap'} style={{alignItems: 'center'}}>
            <button className={'flex-grow'}
                    title={'Broadcast theme edits (images, packs, sounds, tech-tree art) live to your own running game sessions. The game opts in with its live_preview console setting.'}
                    onClick={() => livePreview.setEnabled(!status.enabled)}>
                <span className={'fa-solid fa-tower-broadcast'}
                      style={{marginRight: 6, color: status.connected ? green : 'white', opacity: status.connected ? 1 : 0.4}}/>
                <span style={{color: status.receivers > 0 ? green : 'white'}}>Live Preview</span>
            </button>
        </div>
    );
}

export default LivePreviewControl;
